import {
  CreateSourceWebhookPhase,
  WebhookCredentials,
} from "@/pages/sources/components/create/sources/webhook/types";

export enum CreateSourceWebhookActionType {
  SET_SOURCE_NAME = "SET_SOURCE_NAME",
  SET_PHASE = "SET_PHASE",
  SET_SIGNATURE_HEADER = "SET_SIGNATURE_HEADER",
  SET_BATCH_INTERVAL_SECONDS = "SET_BATCH_INTERVAL_SECONDS",
  SET_BATCH_MAX_SIZE = "SET_BATCH_MAX_SIZE",
  SET_CREDENTIALS = "SET_CREDENTIALS",
  SET_SOURCE_ID = "SET_SOURCE_ID",
  SET_ERROR = "SET_ERROR",
  SET_SHOULD_SHOW_ERRORS = "SET_SHOULD_SHOW_ERRORS",
}

export interface SetSourceNameAction {
  type: CreateSourceWebhookActionType.SET_SOURCE_NAME;
  payload: string;
}

export interface SetPhaseAction {
  type: CreateSourceWebhookActionType.SET_PHASE;
  payload: CreateSourceWebhookPhase;
}

export interface SetSignatureHeaderAction {
  type: CreateSourceWebhookActionType.SET_SIGNATURE_HEADER;
  payload: string;
}

export interface SetBatchIntervalSecondsAction {
  type: CreateSourceWebhookActionType.SET_BATCH_INTERVAL_SECONDS;
  payload: number | null;
}

export interface SetBatchMaxSizeAction {
  type: CreateSourceWebhookActionType.SET_BATCH_MAX_SIZE;
  payload: number | null;
}

export interface SetCredentialsAction {
  type: CreateSourceWebhookActionType.SET_CREDENTIALS;
  payload: WebhookCredentials;
}

export interface SetSourceIdAction {
  type: CreateSourceWebhookActionType.SET_SOURCE_ID;
  payload: string;
}

export interface SetErrorAction {
  type: CreateSourceWebhookActionType.SET_ERROR;
  payload: string | null;
}

export interface SetShouldShowErrorsAction {
  type: CreateSourceWebhookActionType.SET_SHOULD_SHOW_ERRORS;
  payload: boolean;
}

export type CreateSourceWebhookAction =
  | SetSourceNameAction
  | SetPhaseAction
  | SetSignatureHeaderAction
  | SetBatchIntervalSecondsAction
  | SetBatchMaxSizeAction
  | SetCredentialsAction
  | SetSourceIdAction
  | SetErrorAction
  | SetShouldShowErrorsAction;
